import type { GovernOwnership } from "owa-bundling-light";
import { lazyGovern } from "./lazyFunctions";
import type { GovernedTaskName } from "owa-client-types/lib/GovernedTaskName";

export function governOrEvent<T>(name: GovernedTaskName, ownership: GovernOwnership, task: () => Promise<T>, eventCb: Promise<void>): Promise<T> {
    return new Promise<T>((res, rej) => {
        let taskFinished = false;
        function callTask() {
            if (!taskFinished) {
                taskFinished = true;
                task().then(res).catch(rej);
            }
        }
        
        // this is a race between the govern task and the event cb.
        lazyGovern.importAndExecute({
            task: callTask,
            name,
            ownership,
        });
        eventCb.then(callTask);
    });
}
